import { ImageDialogComponent } from "./../image-dialog/image-dialog.component";
import { Component, OnInit, HostListener } from "@angular/core";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { DataService } from "src/app/Services/dataservice.service";

import { UserserviceService } from "src/app/Services/userservice.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { TitleandmetaserviceService } from "src/app/Services/titleandmetaservice.service";
import { ViewUserProfileQrCodeComponent } from "../view-user-profile-qr-code/view-user-profile-qr-code.component";
import { FlowQueryService } from "src/app/shared/flowquery.helper";
import { FlowQueryModel, UserQueryModel } from "src/app/models/flowquerymodel";
import { DonationPopupComponent } from "../donation-popup/donation-popup.component";
import { title } from "process";
import { ToastrService } from "ngx-toastr";
import { TranslationService } from "src/app/Services/translation.service";
import {
  getFeedPosterUrl,
  trackFeedItem,
} from "src/app/utils/feed-thumbnail.util";
import { resolveProfilePicUrl } from "src/app/utils/profile-pic.util";
import { FrontlineGlossary } from "src/app/shared/constants/frontline-glossary";

type ViewProfileTabId = "guides" | "guidePacks" | "builds";

@Component({
  selector: "app-view-profile",
  templateUrl: "./view-profile.component.html",
  styleUrls: ["./view-profile.component.scss"],
})
export class ViewProfileComponent implements OnInit {
  showNotificationCount: boolean;
  notificationCount: number;

  name: string;
  email: string;
  website: string;
  phone: string;
  info: string;
  uname: string;
  profilePicture: string;

  isthereAnyFlows: boolean = true;
  isthereAnyBundles: boolean = true;

  flows: any = [];
  bundles: any[] = [];
  approvedFlows: any = [];
  userData: any;
  showDefaultImage: boolean;
  currentImage: any;
  previousIndex: any;
  showImg = false;
  arrow = false;
  itemCount = 0;
  scrHeight: any;
  scrWidth: any;
  SlideOptions: any;
  followButtonText: any;
  isFollowLoading = false;
  FlowCount: number = 0;
  Bundlecount: number = 0;
  FollowersCount: number = 0;
  FollowingCount: number = 0;
  tempFlows: any[] = [];
  tempBundles: any[] = [];
  userBuilds: any[] = [];
  isthereAnyBuilds: boolean = false;
  BuildsCount: number = 0;
  hasLoadedBuilds: boolean = false;

  isInitialProfileDataLoading: boolean = true;
  isInitialContentLoading: boolean = true;
  isInitialDataLoading: boolean = true;
  isLoadingMore: boolean = false;
  noMoreFlows: boolean = false;
  private readonly PAGE_SIZE = 15;
  activeTabIndex: number = 0;
  // Prevent reloading/skeleton on repeated tab switches
  hasLoadedFlows: boolean = false;
  hasLoadedBundles: boolean = false;

  readonly glossary = FrontlineGlossary;
  showPublicLibraryTabs = true;
  visibleTabIds: ViewProfileTabId[] = ["guides", "guidePacks", "builds"];

  getFeedPosterUrl = getFeedPosterUrl;
  trackFlowCard = trackFeedItem;

  isMobileView: boolean = false;
  isSearchOpen: boolean = false;
  searchInput: string = "";
  isSearchActive: boolean = false;
  searchResults: any[] = [];

  userDisplayName: any;
  userEmailAddress: any;
  loggedInEmailAddress: any;
  emailAddress: any;
  noBundles: boolean;
  flow: any;
  ShowName: boolean;
  ShowWebsite: boolean;
  ShowAboutYou: boolean;
  ShowPhone: boolean;
  ShowEmail: boolean;
  otherUserData: any;
  userRowKey: any;
  UserConsultData: void;
  showDonateButton: boolean;
  showConsultButton: boolean;
  filteredBlogs: any[];
  // tslint:disable-next-line: max-line-length
  constructor(
    private flowServiceService: FlowServiceService,
    private dataService: DataService,
    private toastr: ToastrService,
    private router: Router,
    private userserviceService: UserserviceService,
    public dialog: MatDialog,
    private activateRouter: ActivatedRoute,
    private titleandmetaserviceService: TitleandmetaserviceService,
    private flowQueryService: FlowQueryService,
    private translationService: TranslationService
  ) {
    this.titleandmetaserviceService.setTitle("View Other User Profile");
    this.flows = [];
    this.emailAddress = "";
  }

  @HostListener("window:resize")
  onResize(): void {
    const width = window.innerWidth || document.body.clientWidth;
    this.isMobileView = width <= 1200;
    if (!this.isMobileView) {
      this.isSearchOpen = false;
    }
  }

  ngOnInit(): void {
    this.onResize();
    const width = window.innerWidth || document.body.clientWidth;
    this.isMobileView = width <= 1200;
    this.isSearchOpen = this.isMobileView;
    this.isInitialProfileDataLoading = true;
    this.isInitialContentLoading = true;
    this.followButtonText = "Follow";

    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));

    if (this.userData != null && this.userData != undefined) {
      this.loggedInEmailAddress = this.getLoggedInUserEmail();
      this.activateRouter.paramMap.subscribe((params) => {
        const uname = (params.get("uname") || "").replace(/^@/, "").trim();

        if (uname) {
          this.loadProfileByUserName(uname);
        } else {
          this.initProfileWithoutUserName();
        }
      });
    } else {
      // this.router.navigate(["/login"]);
      localStorage.setItem("returnUrl", "/");
      this.router.navigate(["/registration"]);
    }
    localStorage.setItem("flowData", null);
  }

  private initProfileWithoutUserName(): void {
    this.flowServiceService.setScrollTop();
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    this.showNotificationCount = false;
    this.notificationCount = 4;

    if (this.userData != null) {
      this.userDisplayName = this.userData.firstName;
      this.loggedInEmailAddress = this.getLoggedInUserEmail();
    }

    window.scrollTo(0, 0);

    if (!this.applyFlowContextAndLoad(this.getStoredFlowContext())) {
      this.dataService.setFlowByCategorieschangeMessage.subscribe((flowData) => {
        this.applyFlowContextAndLoad(flowData);
      });
    }
  }

  private getStoredFlowContext(): any {
    try {
      const stored = localStorage.getItem("flowByCategory");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  }

  private extractEmailFromFlow(flow: any): string {
    if (!flow || typeof flow !== "object") {
      return "";
    }

    const candidates = [
      flow.customerEmail,
      flow.NotifierUserEmail,
      flow.emailAddress,
      flow.userEmail,
      flow.PartitionKey,
      flow.partitionKey,
    ];

    for (const candidate of candidates) {
      if (candidate != null && String(candidate).trim() !== "") {
        return String(candidate).trim();
      }
    }

    return "";
  }

  private applyFlowContextAndLoad(flow: any): boolean {
    const email = this.extractEmailFromFlow(flow);
    if (!email) {
      return false;
    }

    this.flow = flow;
    this.emailAddress = email;
    this.userEmailAddress = email;
    this.loadProfileContent();
    return true;
  }

  private getLoggedInUserEmail(): string {
    return (
      this.userData?.emailAddress ||
      this.userData?.EmailAddress ||
      this.userData?.partitionKey ||
      this.userData?.PartitionKey ||
      ""
    );
  }

  private applyProfileFromUser(user: any, fromDetailedProfile = false): void {
    if (!user) {
      return;
    }

    const profilePic = resolveProfilePicUrl(
      user.profilePicUrl || user.ProfilePicUrl
    );
    if (profilePic) {
      this.showDefaultImage = false;
      this.profilePicture = profilePic;
    } else {
      this.showDefaultImage = true;
      this.profilePicture = null;
    }

    this.email = user.emailAddress || user.EmailAddress || user.partitionKey || "";
    this.phone = user.phoneNumber || user.PhoneNumber || "";
    this.info = user.info || user.Info || "";
    this.website = user.website || user.Website || "";
    this.uname = user.userName || user.UserName || this.uname;
    this.name = user.firstName || user.FirstName || this.name;
    // Only the detailed profile carries public-profile counts; the username lookup has raw stored totals.
    if (fromDetailedProfile) {
      this.FlowCount = user.flowCount ?? user.FlowCount ?? this.FlowCount ?? 0;
      this.Bundlecount = user.bundlecount ?? user.Bundlecount ?? this.Bundlecount ?? 0;
    }
    this.FollowersCount =
      user.followerCount ?? user.FollowerCount ?? this.FollowersCount ?? 0;
    this.FollowingCount =
      user.followingCount ?? user.FollowingCount ?? this.FollowingCount ?? 0;
    this.userRowKey = user.rowKey || user.RowKey || this.userRowKey;

    if (fromDetailedProfile) {
      this.showDonateButton = !!user.enableAcceptFunds;
      this.showConsultButton = !!user.enableConsultation;
      this.ShowName = user.showName ?? user.ShowName;
      this.ShowWebsite = user.showWebsite ?? user.ShowWebsite;
      this.ShowAboutYou = user.showAboutYou ?? user.ShowAboutYou;
      this.ShowPhone = user.showPhone ?? user.ShowPhone;
      this.ShowEmail = user.showEmail ?? user.ShowEmail;
      this.followButtonText = user.isFollowing ? "Following" : "Follow";
      this.UserConsultData = user;
    }

    this.updatePublicLibraryTabs(user);
    this.isInitialProfileDataLoading = false;
  }

  getActiveTabId(): ViewProfileTabId {
    return (
      this.visibleTabIds[this.activeTabIndex] ||
      this.visibleTabIds[0] ||
      "builds"
    );
  }

  isActiveTab(id: ViewProfileTabId): boolean {
    return this.getActiveTabId() === id;
  }

  private updatePublicLibraryTabs(user?: any): void {
    // Public profiles always expose Guides, Guide Packs, and Builds.
    this.showPublicLibraryTabs = true;
    this.visibleTabIds = ["guides", "guidePacks", "builds"];

    if (this.activeTabIndex >= this.visibleTabIds.length) {
      this.activeTabIndex = 0;
    }
  }

  private loadProfileByUserName(uname: string): void {
    this.userserviceService.getUserByUserName(uname).subscribe({
      next: (data) => {
        const user = data?.user;
        const profileEmail =
          user?.emailAddress ||
          user?.EmailAddress ||
          user?.partitionKey ||
          user?.PartitionKey ||
          "";
        if (profileEmail) {
          this.userEmailAddress = profileEmail;
          this.emailAddress = profileEmail;
          this.applyProfileFromUser(user);
          this.loadProfileContent();
        } else {
          console.error("Invalid user data received:", data);
          this.isInitialProfileDataLoading = false;
          this.isInitialContentLoading = false;
          this.toastr.error("User not found");
        }
      },
      error: (error) => {
        console.error("Error loading user profile:", error);
        this.isInitialProfileDataLoading = false;
        this.isInitialContentLoading = false;
        this.toastr.error("Failed to load user profile");
      },
    });
  }

  private loadProfileContent(): void {
    this.hasLoadedFlows = false;
    this.hasLoadedBundles = false;
    this.hasLoadedBuilds = false;
    this.isInitialContentLoading = true;
    this.isthereAnyFlows = true;
    this.isthereAnyBundles = true;
    if (this.showPublicLibraryTabs) {
      this.getFlows();
      this.getBundles();
    } else {
      this.hasLoadedFlows = true;
      this.hasLoadedBundles = true;
      this.isthereAnyFlows = false;
      this.isthereAnyBundles = false;
    }
    this.getUserBuilds();
    this.viewUserProfile();
    this.getUserBlogs();
  }

  giftToUser() {
    const dialogRef = this.dialog.open(DonationPopupComponent, {
      panelClass: ["dialoguebox", "donation-dialog-panel"],
    });
    dialogRef.afterClosed().subscribe((donationAmount) => {
      if (donationAmount !== undefined && donationAmount > 0) {
        this.otherUserData = {
          emailAddress: this.email,
          rowKey: this.userRowKey,
          type: "User",
          price: donationAmount, // Add the donation amount here
          title: "Donate to " + this.uname,
          // customerEmail : this.userData.partitionKey
        };
        localStorage.setItem(
          "checkoutFlow",
          JSON.stringify(this.otherUserData)
        );
        this.router.navigate(["/checkout"]);
      } else if (donationAmount == 0) {
        this.toastr.warning("Donatation amount can not be 0");
      }
    });
  }

  getFlows(): void {
    if (this.isSearchActive) {
      return;
    }

    this.isInitialDataLoading = !this.hasLoadedFlows;
    if (!this.hasLoadedFlows) {
      this.isInitialContentLoading = true;
    }

    this.flows = [];
    this.tempFlows = [];
    this.isthereAnyFlows = true;
    this.noMoreFlows = false;

    localStorage.removeItem("pageIndex");
    localStorage.setItem("pageIndex", "0");

    const flowQueryModel = new FlowQueryModel({
      category: "",
      searchString: "",
      userEmail: this.emailAddress,
      pageIndex: 0,
      publicProfileView: true,
    });

    this.flowServiceService
      .getAllUserFlows(flowQueryModel)
      .subscribe({
        next: (data) => {
          const results = data?.flows || [];
          this.flows = results;
          this.tempFlows = [...this.flows];
          this.isthereAnyFlows = this.tempFlows.length > 0;
          if (!this.FlowCount) {
            this.FlowCount = this.tempFlows.length;
          }
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.isLoadingMore = false;
          this.hasLoadedFlows = true;
        },
        error: () => {
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.isLoadingMore = false;
          this.isthereAnyFlows = false;
          this.hasLoadedFlows = true;
        }
      });
  }

  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  onScrollDown() {
    if (this.isSearchActive || this.isLoadingMore || this.noMoreFlows) {
      return;
    }
    this.isLoadingMore = true;
    this.delay(2000).then(() => {
      this.delayedServiceCall();
    });
  }

  delayedServiceCall() {
    if (this.isSearchActive) {
      this.isLoadingMore = false;
      return;
    }

    const pageIndex = parseInt(localStorage.getItem("pageIndex") || "0", 10);
    const nextPage = pageIndex + 1;
    localStorage.setItem("pageIndex", nextPage.toString());

    const flowQueryModel = new FlowQueryModel({
      category: "",
      searchString: "",
      userEmail: this.emailAddress,
      pageIndex: nextPage,
      publicProfileView: true,
    });

    this.flowServiceService
      .getAllUserFlows(flowQueryModel)
      .subscribe({
        next: (data) => {
          const results = data?.flows || [];
          if (results.length > 0) {
            const existingKeys = new Set(this.flows.map((f) => f.rowKey));
            const newFlows = results.filter((f) => !existingKeys.has(f.rowKey));
            if (newFlows.length > 0) {
              this.flows = [...this.flows, ...newFlows];
              this.tempFlows = [...this.flows];
              this.scheduleRetranslate();
            }
            if (results.length < this.PAGE_SIZE) {
              this.noMoreFlows = true;
            }
          } else {
            this.noMoreFlows = true;
          }
          this.isLoadingMore = false;
        },
        error: () => {
          this.isLoadingMore = false;
          this.noMoreFlows = true;
        }
      });
  }

  private scheduleRetranslate(): void {
    if (this.translationService.getCurrentTranslationLanguage()) {
      setTimeout(() => this.translationService.retranslateForNewContent(), 200);
    }
  }

  public tabChanged(tabChangeEvent: any): void {
    this.activeTabIndex = tabChangeEvent.index;
    const tabId = this.getActiveTabId();

    if (this.isSearchActive) {
      this.search();
      return;
    }

    const needsLoad =
      (tabId === "guides" && !this.hasLoadedFlows) ||
      (tabId === "guidePacks" && !this.hasLoadedBundles) ||
      (tabId === "builds" && !this.hasLoadedBuilds);

    this.isInitialDataLoading = needsLoad;

    // If the tab's data is already loaded, make sure the skeleton is off immediately
    if (!needsLoad) {
      this.isInitialContentLoading = false;
    }

    if (tabId === "guides" && !this.hasLoadedFlows) {
      this.getFlows();
    }

    if (tabId === "guidePacks" && !this.hasLoadedBundles) {
      this.getBundles();
    }

    if (tabId === "builds" && !this.hasLoadedBuilds) {
      this.getUserBuilds();
    }
  }

  checkLoggedIn() {
    if (this.userData === null) {
      // this.router.navigate(["/login"]);
      localStorage.setItem("returnUrl", "/");
      this.router.navigate(["/registration"]);
    } else {
      this.router.navigate(["/create-guide"]);
    }
  }

  followUser() {
    if (this.userData != null) {
      if (this.isFollowLoading) {
        return;
      }
      this.isFollowLoading = true;
      //
      const flowModel = {
        UserEmail: this.userEmailAddress,
        FollowerEmail: this.loggedInEmailAddress,
      };
      this.flowServiceService.FollowUser(flowModel).subscribe((data) => {
        if (data.isFollowing === "following") {
          this.followButtonText = "Following";
        } else {
          this.followButtonText = "Follow";
        }
        this.isFollowLoading = false;
        //
      }, () => {
        this.isFollowLoading = false;
      });
    } else {
      // this.router.navigate(["/login"]);
      localStorage.setItem("returnUrl", "/");
      this.router.navigate(["/registration"]);
    }
  }

  checkIsUserLoggedIn() {
    if (this.userData === null) {
      // this.router.navigate(["/login"]);
      localStorage.setItem("returnUrl", "/");
      this.router.navigate(["/registration"]);
    }
  }

  getProfileUser(): void {
    if (this.userData != null) {
      //
      this.showNotificationCount = true;
      this.userserviceService.getProfileUser().subscribe((data) => {
        if (
          data.userData.profilePicUrl === "" ||
          data.userData.profilePicUrl == null
        ) {
          this.showDefaultImage = true;
        } else {
          this.showDefaultImage = false;
          this.profilePicture = data.userData.profilePicUrl;
        }
        this.email = data.userData.emailAddress;
        this.phone = data.userData.phoneNumber;
        this.info = data.userData.info;
        this.website = data.userData.website;
        this.uname = data.userData.userName;
        this.name = data.userData.firstName;
      });
    }
  }

  SignOut() {
    localStorage.setItem("LoggedInUser", null);
    this.userDisplayName = null;
  }

  // flowClicked(flow) {
  //   localStorage.setItem("flow", JSON.stringify(flow));
  //   localStorage.setItem("notificationflowId", null);
  //   this.router.navigate(["/view/" + flow.Id]);
  // }

  openFlowCreatorProfile(selectedFlow: any): void {
    if (!selectedFlow || this.userData == null) {
      return;
    }
    if (this.userData.emailAddress === selectedFlow.customerEmail) {
      this.router.navigate(["/user-profile"]);
    } else if (selectedFlow.userName) {
      this.router.navigate([
        "/view-profile",
        selectedFlow.userName.replace(/^@/, ""),
      ]);
    } else {
      this.dataService.flowByCategorieschangeMessage(selectedFlow);
      this.router.navigate(["/view-profile"]);
    }
  }

  viewUserProfile(): void {
    if (!this.userEmailAddress) {
      this.isInitialDataLoading = false;
      this.isInitialProfileDataLoading = false;
      return;
    }

    const flowQueryModel = new UserQueryModel();
    flowQueryModel.userEmail = this.loggedInEmailAddress;
    flowQueryModel.otherUserEmail = this.userEmailAddress;
    this.userserviceService.viewUserProfile(flowQueryModel).subscribe({
      next: (data) => {
        if (!data?.userData) {
          this.isInitialDataLoading = false;
          if (!this.uname) {
            this.isInitialProfileDataLoading = false;
            this.toastr.error("User profile not found");
          }
          return;
        }

        this.applyProfileFromUser(data.userData, true);
        this.isInitialDataLoading = false;
      },
      error: (error) => {
        console.error("Error loading user profile details:", error);
        this.isInitialDataLoading = false;
        this.isInitialProfileDataLoading = false;
        if (!this.uname) {
          this.toastr.error("Failed to load user profile");
        }
      },
    });
  }

  viewCoAuthorProfile(item: any, event: Event): void {
    event.stopPropagation();
    if (!item.coAuthorEmail) return;
    if (this.userData?.emailAddress === item.coAuthorEmail) {
      this.router.navigate(['/user-profile']);
    } else if (item.coAuthorUserName) {
      this.router.navigate(['/view-profile', item.coAuthorUserName.replace(/^@/, '')]);
    } else {
      this.dataService.flowByCategorieschangeMessage({ customerEmail: item.coAuthorEmail });
      this.router.navigate(['/view-profile']);
    }
  }

  /** Item whose collaborators popup is currently open (null = closed). */
  collabPopupItem: any = null;
  collabPopupCoAuthors: { email: string; userName: string; profilePicUrl: string }[] = [];

  showCollabPopup(item: any, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = this.collabPopupItem === item ? null : item;
    this.collabPopupCoAuthors = this.collabPopupItem ? this.getCollabCoAuthors(this.collabPopupItem) : [];
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.collabPopupItem = null;
    this.collabPopupCoAuthors = [];
  }

  navigateToUserFromPopup(item: any, isCoAuthor: boolean, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = null;
    this.collabPopupCoAuthors = [];
    if (isCoAuthor) {
      this.viewCoAuthorProfile(item, event);
    } else {
      if (this.userData?.emailAddress === item.customerEmail) {
        this.router.navigate(['/user-profile']);
      } else if (item.userName) {
        this.router.navigate(['/view-profile', item.userName.replace(/^@/, '')]);
      } else {
        this.dataService.flowByCategorieschangeMessage(item);
        this.router.navigate(['/view-profile']);
      }
    }
  }

  isCollabFlow(item: any): boolean {
    if (!(item?.isCollaboration || item?.IsCollaboration)) return false;
    if (!(item?.coAuthorEmail || item?.CoAuthorEmail)) return false;
    // Check per-person statuses first (array wins over single status)
    const statusesRaw = item?.coAuthorStatuses || item?.CoAuthorStatuses || null;
    if (statusesRaw) {
      try {
        const statuses: string[] = JSON.parse(statusesRaw);
        return statuses.some(s => s === 'Accepted');
      } catch {}
    }
    // Fall back to single collaborationStatus field
    const status = item?.collaborationStatus || item?.CollaborationStatus || '';
    return status === 'Accepted';
  }

  /** Returns the first accepted co-author's username for the "and @username" text on flow cards. */
  coAuthorDisplay(item: any): string {
    const accepted = this.getCollabCoAuthors(item);
    return accepted.length > 0 ? accepted[0].userName : '';
  }

  getCollabCoAuthors(item: any): { email: string; userName: string; profilePicUrl: string }[] {
    if (!item) return [];
    const coAuthorEmail     = item.coAuthorEmail    || item.CoAuthorEmail    || null;
    const coAuthorUserName  = item.coAuthorUserName || item.CoAuthorUserName || null;
    const coAuthorPicUrl    = item.coAuthorProfilePicUrl || item.CoAuthorProfilePicUrl || null;
    const coAuthorEmails    = item.coAuthorEmails    || item.CoAuthorEmails    || null;
    const coAuthorUserNames = item.coAuthorUserNames || item.CoAuthorUserNames || null;
    const coAuthorPicUrls   = item.coAuthorProfilePicUrls || item.CoAuthorProfilePicUrls || null;
    const coAuthorStatuses  = item.coAuthorStatuses  || item.CoAuthorStatuses  || null;
    let emails: string[] = [];
    let userNames: string[] = [];
    let profilePicUrls: string[] = [];
    let statuses: string[] = [];
    try { if (coAuthorEmails) emails = JSON.parse(coAuthorEmails); } catch {}
    try { if (coAuthorUserNames) userNames = JSON.parse(coAuthorUserNames); } catch {}
    try { if (coAuthorPicUrls) profilePicUrls = JSON.parse(coAuthorPicUrls); } catch {}
    try { if (coAuthorStatuses) statuses = JSON.parse(coAuthorStatuses); } catch {}
    const singleStatus = item?.collaborationStatus || item?.CollaborationStatus || '';
    if (Array.isArray(emails) && emails.length > 0) {
      return emails
        .map((email, i) => ({
          email,
          userName: userNames[i] || (i === 0 ? coAuthorUserName : '') || email,
          profilePicUrl: profilePicUrls[i] || (i === 0 ? coAuthorPicUrl : '') || '',
          // CoAuthorStatuses is not persisted by the backend; fall back to the flow's
          // CollaborationStatus for every slot so all accepted co-authors are visible.
          status: statuses[i] || singleStatus,
        }))
        .filter(c => c.status === 'Accepted');
    }
    if (coAuthorEmail && singleStatus === 'Accepted') {
      return [{ email: coAuthorEmail, userName: coAuthorUserName || coAuthorEmail, profilePicUrl: coAuthorPicUrl || '' }];
    }
    return [];
  }

  getExtraCollabCount(item: any): number {
    return Math.max(0, this.getCollabCoAuthors(item).length - 1);
  }

  navigateToCoAuthorProfile(coAuthor: { email: string; userName: string; profilePicUrl: string }, event: Event): void {
    event.stopPropagation();
    this.collabPopupItem = null;
    this.collabPopupCoAuthors = [];
    const syntheticItem = { coAuthorEmail: coAuthor.email, coAuthorUserName: coAuthor.userName };
    this.viewCoAuthorProfile(syntheticItem, event);
  }

  openDialog() {
    localStorage.setItem("profilePicture", JSON.stringify(this.profilePicture));
    this.dialog.open(ImageDialogComponent);
  }
  ConsultBooking() {
    localStorage.setItem(
      "CreatorUserConsultation",
      JSON.stringify(this.UserConsultData)
    );
    this.router.navigateByUrl("/bookconsultation");
  }

  gotoUserQrCode() {
    localStorage.removeItem("otherUserEmailAddress");
    localStorage.removeItem("otherUseruname");
    localStorage.setItem("otherUserEmailAddress", this.emailAddress);
    localStorage.setItem("otherUseruname", this.uname);
    const dialogRef = this.dialog.open(ViewUserProfileQrCodeComponent, {
      panelClass: "dialoguebox",
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.scrHeight = window.innerHeight;
    this.scrWidth = window.innerWidth;
    if (this.scrWidth >= 900) {
      this.SlideOptions = { items: 5, dots: false, nav: true };
    }
    if (this.scrWidth >= 700 && this.scrWidth < 900) {
      this.SlideOptions = { items: 4, dots: false, nav: true };
    }
    if (this.scrWidth >= 600 && this.scrWidth < 700) {
      this.SlideOptions = { items: 3, dots: false, nav: true };
    }
    if (this.scrWidth >= 479 && this.scrWidth < 600) {
      this.SlideOptions = { items: 2, dots: false, nav: true };
    }
    if (this.scrWidth < 479) {
      this.SlideOptions = { items: 2, dots: false, nav: true };
    }
  }
  showImage(itemCategory, item, index) {
    itemCategory.FlowModels.forEach((element) => {
      if ((element.arrow! = undefined)) {
        element.arrow = false;
      }
    });
    if (!itemCategory.showImg || index !== this.previousIndex) {
      this.currentImage = item.Url;
      this.previousIndex = index;
      itemCategory.showImg = true;
      item.arrow = true;
    } else {
      itemCategory.showImg = false;
      item.arrow = false;
    }
  }

  getBundles() {
    if (this.isSearchActive) {
      return;
    }

    this.isInitialDataLoading = !this.hasLoadedBundles;
    if (!this.hasLoadedBundles) {
      this.isInitialContentLoading = true;
    }

    this.noBundles = true;
    this.isthereAnyBundles = true;
    this.bundles = [];
    this.tempBundles = [];

    const flowQueryModel = new FlowQueryModel({
      category: "",
      searchString: "",
      userEmail: this.emailAddress,
      pageIndex: 0,
      publicProfileView: true,
    });

    this.flowServiceService
      .getUserPublicBundles(flowQueryModel)
      .subscribe({
        next: (data) => {
          const results = data?.bundles || [];
          this.bundles = results;
          this.tempBundles = [...this.bundles];
          this.isthereAnyBundles = this.tempBundles.length > 0;
          this.noBundles = this.tempBundles.length === 0;
          if (!this.Bundlecount) {
            this.Bundlecount = this.tempBundles.length;
          }
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.hasLoadedBundles = true;
        },
        error: () => {
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.isthereAnyBundles = false;
          this.noBundles = true;
          this.hasLoadedBundles = true;
        }
      });
  }

  flowClicked(flow) {
    localStorage.setItem("flow", JSON.stringify(flow));

    localStorage.setItem("notificationflowId", null);
    //localStorage.setItem("flow", JSON.stringify(flow));
    //  localStorage.removeItem("flow"); //, JSON.stringify(flow));
    localStorage.setItem("navigateTo", "/");
    if (flow.type == "Bundle") {
      //this.isItBundle = true;
      this.router.navigate(["/view-guide-pack/" + flow.rowKey]);
    } else {
      //this.isItBundle = false;
      this.router.navigate([
        `/guide/${this.generateUrlSlug(flow.title)}/${flow.rowKey}`,
      ]);
    }
  }

  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  getUserBlogs() {
    var flowQueryModel = new FlowQueryModel({
      userEmail: this.userEmailAddress,
    });
    this.filteredBlogs = [];
    this.flowServiceService
      .getAllUserBlogs(flowQueryModel)
      .subscribe((data) => {
        // Filter only blogs where featureOnProfile is true
        this.filteredBlogs = (data || []).filter(
          (blog) => blog.featureOnProfile === true
        );
      });
  }

  viewAllBlogs() {
    localStorage.setItem("SelectedUserEmail", this.userEmailAddress);
    localStorage.setItem("SelectedUserName", this.uname || "");
    this.router.navigateByUrl("/bulbguide");
  }

  viewblog(blog: any) {
    localStorage.setItem("selectedBlogContent", JSON.stringify(blog));
    this.router.navigate(["/blog/" + this.getTitle(blog.title)]);
  }

  getTitle(title: any) {
    // Replace spaces with hyphens and convert to lowercase
    return title.replace(/\s+/g, "-");
  }

  toggleSearch() {
    this.isSearchOpen = !this.isSearchOpen;
    if (!this.isSearchOpen) {
      this.searchInput = "";
      this.resetSearch();
    }
  }

  onSearchInputChange(): void {
    this.search();
  }

  clearProfileMobileSearchInput(): void {
    this.searchInput = "";
    this.search();
  }

  search() {
    const term = (this.searchInput || "").trim().toLowerCase();
    if (!term) {
      this.resetSearch();
      return;
    }

    this.isSearchActive = true;
    const tabId = this.getActiveTabId();

    if (tabId === "guides") {
      this.tempFlows = (this.flows || []).filter((flow) =>
        [flow?.title, flow?.description, flow?.uniqueId]
          .filter(Boolean)
          .some((field) => field.toString().toLowerCase().includes(term))
      );
      this.isthereAnyFlows = this.tempFlows.length > 0;
    } else if (tabId === "guidePacks") {
      this.tempBundles = (this.bundles || []).filter((bundle) =>
        [bundle?.title, bundle?.description, bundle?.uniqueId]
          .filter(Boolean)
          .some((field) => field.toString().toLowerCase().includes(term))
      );
      this.isthereAnyBundles = this.tempBundles.length > 0;
    } else if (tabId === "builds") {
      // Search in Builds
      const filteredBuilds = (this.userBuilds || []).filter((build) =>
        [build?.flowTitle, build?.flowUniqueId]
          .filter(Boolean)
          .some((field) => field.toString().toLowerCase().includes(term))
      );
      // Note: We'd need a tempBuilds array if we want to filter builds
      // For now, just keep the original behavior
    }
  }

  resetSearch() {
    this.isSearchActive = false;
    this.searchResults = [];
    this.tempFlows = [...(this.flows || [])];
    this.tempBundles = [...(this.bundles || [])];
    this.isthereAnyFlows = this.tempFlows.length > 0;
    this.isthereAnyBundles = this.tempBundles.length > 0;
  }

  getUserBuilds(): void {
    if (this.hasLoadedBuilds) {
      return; // Already loaded, don't reload
    }

    if (!this.emailAddress && !this.userEmailAddress) {
      this.isInitialContentLoading = false;
      this.isthereAnyBuilds = false;
      this.userBuilds = [];
      this.BuildsCount = 0;
      this.hasLoadedBuilds = true;
      return;
    }

    this.isInitialDataLoading = !this.hasLoadedBuilds;
    if (!this.hasLoadedBuilds) {
      this.isInitialContentLoading = true;
    }

    const userEmail = this.userEmailAddress || this.emailAddress;

    // For view-profile page, we want ALL builds created by the profile owner
    // Pass empty array to query all reviews across all flows and filter by creatorEmail
    // This will get builds created by the profile owner on any flow, not just their own flows
    this.flowServiceService
      .getUserShorts(userEmail, [])
      .subscribe({
        next: (shortsData) => {
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          
          // Backend filters by creatorEmail, so we can use the results directly
          if (shortsData?.shorts && shortsData.shorts.length > 0) {
            this.isthereAnyBuilds = true;
            this.userBuilds = shortsData.shorts;
            this.BuildsCount = shortsData.shorts.length;
          } else {
            this.isthereAnyBuilds = false;
            this.BuildsCount = 0;
          }
          this.hasLoadedBuilds = true;
        },
        error: (error) => {
          console.error("Error loading builds:", error);
          this.isInitialDataLoading = false;
          this.isInitialContentLoading = false;
          this.isthereAnyBuilds = false;
          this.BuildsCount = 0;
          this.hasLoadedBuilds = true;
        }
      });
  }
}
